import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    friendsIncoming: {},
    count: '',
    next: '',
    errors: {}
};

getters['fetchIncoming'] = function(state) { return state.friendsIncoming }
getters['fetchIncomingCount'] = function(state) { return state.count }
getters['fetchIncomingNext'] = function(state) { return state.next }

const actions = {
    get(context, payload=false) {
        let url =
            payload ?
            'friends/requests/?q=' + payload :
            'friends/requests/';
        return ApiService
            .get(url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_REQUESTS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_REQUESTS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    accept(context, payload) {
        return ApiService
            .get('friends/requests/' + payload + '/accept/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_REQUEST', payload);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_REQUESTS(state, friendsIncoming) {
        state.friendsIncoming = friendsIncoming;
        state.errors = {};
    },
    ADD_REQUESTS(state, friendsIncoming) {
        state.friendsIncoming = state.friendsIncoming.concat(friendsIncoming);
    },
    REMOVE_REQUEST(state, request) {
        for (let i in state.friendsIncoming) {
            if (state.friendsIncoming[i].id == request) {
                state.friendsIncoming.splice(i, 1);
            }
        }
        state.count = --state.count;
    },
    SET_NEXT(state, data) {
        let symbol = data.url.indexOf('?') == -1 ? '?' : '&';
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            symbol +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
